import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import {
  AcademicManagementExcelResponse,
  AcademicManagementFollowUpQuery,
  ExportAcademicManagementFollowUpQuery,
} from 'domain/models';

const handleResponse = <T>(statusCode: HttpStatusCode, body: T): T => {
  switch (statusCode) {
    case HttpStatusCode.ok:
      return body;
    case HttpStatusCode.forbidden:
      throw new InvalidCredentialsError();
    default:
      throw new UnexpectedError((body as { message?: string }).message);
  }
};

export class RemoteGetAcademicManagementReport<TResult> {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<TResult>,
  ) {}

  async execute(params: AcademicManagementFollowUpQuery): Promise<TResult> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, params),
      responseType: 'json',
    });

    return handleResponse(httpResponse.statusCode, httpResponse.body);
  }
}

export class RemoteExportAcademicManagementReport {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<AcademicManagementExcelResponse>,
  ) {}

  async execute(
    params: ExportAcademicManagementFollowUpQuery,
  ): Promise<AcademicManagementExcelResponse> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, params),
      responseType: 'json',
    });

    return handleResponse(httpResponse.statusCode, httpResponse.body);
  }
}
